var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { TimedChangbleFrame } from "../../../../components";
var betFinishedClass = "rj-my-pulse-bets__bet-finished-frame";
var BetFinishedFrame = /** @class */ (function (_super) {
    __extends(BetFinishedFrame, _super);
    function BetFinishedFrame() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BetFinishedFrame.prototype.render = function () {
        var _this = this;
        var viewData = [];
        /*istanbul ignore next */
        if (this.props.won) {
            /*istanbul ignore next */
            viewData.push({
                childrenData: { timeOutMili: 2000 },
                element: React.createElement("div", { className: betFinishedClass + " " + betFinishedClass + "--container" },
                    React.createElement("div", { className: betFinishedClass + "-message " + betFinishedClass + "-message-goal" }, this.props.goMsg))
            });
            /*istanbul ignore next */
            viewData.push({
                childrenData: {
                    timeOutMili: 3800,
                    /* istanbul ignore next */
                    timedOutHandler: function () { return _this.setState({ previewFinished: true }); }
                },
                element: React.createElement("div", { className: betFinishedClass + " " + betFinishedClass + "--container" },
                    React.createElement("div", { className: betFinishedClass + "-message " + betFinishedClass + "-message-win" }, this.props.winMsg))
            });
        }
        /* istanbul ignore next */
        viewData.push({
            childrenData: { timeOutMili: 5000, timedOutHandler: function () { return _this.props.removeBetHandler(); } },
            element: React.createElement("div", { className: betFinishedClass + " " + betFinishedClass + "--try-again-wrapper" })
        });
        return (React.createElement(TimedChangbleFrame, { key: "2", childrenData: viewData.map(function (d) { return d.childrenData; }) }, viewData.map(function (d, index) { return React.createElement(React.Fragment, { key: index }, d.element); })));
    };
    return BetFinishedFrame;
}(React.Component));
export { BetFinishedFrame };
//# sourceMappingURL=BetFinishedFrame.js.map